import * as React from 'react';
import ReactDOM from 'react-dom';

import Format from 'app/src/data/Format';
import Localize from 'app/src/localize/Localize';
import BaseItemView from 'app/src/views/base/BaseItemView';

import { PaymentCreditDebitRefundByRefView } from './PaymentCreditDebitRefundByRefView';
// events triggered by a PaymentCreditRefundByRefView
const _Event = {
  REFUND_BY_REF_AMOUNT_CHANGED: 'refund:by:ref:amount:changed',
  REFUND_BY_REF_ADD_REFUND_CLICKED: 'refund:by:ref:add:refund:clicked',
  REFUND_BY_REF_CANCEL_CLICKED: 'refund:by:ref:cancel:clicked',
  REFUND_BY_REF_TIP_AMOUNT_CLICKED: 'refund:by:ref:tip:amount:clicked', // onRefundByRefTipAmountClicked
};

// configure
let View = BaseItemView.extend({
  template: false,
  onRender() {
    const onClickTipRefundButton = ({ refundTip = false } = {}) => {
      this.trigger(_Event.REFUND_BY_REF_TIP_AMOUNT_CLICKED, { refundTip });
    };
    ReactDOM.render(
      <PaymentCreditDebitRefundByRefView
        viewData={this.viewData}
        onClickTipRefundButton={onClickTipRefundButton}
      />,
      this.el
    );
  },
  onDestroy() {
    ReactDOM.unmountComponentAtNode(this.el);
  },

  ui: {
    maximumRefund: '#maximum_refund',
    originalChargeMessage: '#original_charge_message',
    amount: '#credit_card_amount',
    addRefundButton: '#add_refund',
    cancelButton: '#refund_cancel',
  },

  events: {
    'change @ui.amount': 'amountChanged',
    'click @ui.addRefundButton': 'addRefundClicked',
  },

  triggers: {
    'click @ui.addRefundButton': _Event.REFUND_BY_REF_ADD_REFUND_CLICKED,
    'click @ui.cancelButton': _Event.REFUND_BY_REF_CANCEL_CLICKED,
  },
});

// define
export default class PaymentCreditRefundByRefView extends View {
  static Event() {
    return _Event;
  }

  /**
   * Enables/disables the add refund button.
   *
   * @param {boolean} enabled     When true, the add refund button will be enabled
   */
  enableAddRefundButton(enabled) {
    this.ui.addRefundButton.prop('disabled', !enabled);
  }

  /**
   * Sets the maximum refund field
   *
   * @param maximumRefund {Decimal}    The maximum refund amount
   */
  setMaximumRefund(maximumRefund) {
    this.ui.maximumRefund.text(Format.formatMoney(maximumRefund));

    this.setRefundAmount(maximumRefund);
  }

  /**
   * Shows the original charge message.  If shown, the amount field
   * will be disabled.
   *
   * @param show {boolean}    When true, the original charge message will be shown
   */
  showOriginalChargeMessage(show) {
    if (show) {
      this.ui.originalChargeMessage.show();
      this.ui.amount.prop('disabled', true);
    } else {
      this.ui.originalChargeMessage.hide();
      this.ui.amount.prop('disabled', false);
    }
  }

  /**
   * Sets the value of the refund amount input field.
   *
   * @param amount {Decimal}  The amount
   */
  setRefundAmount(amount) {
    this.ui.amount.val(Format.formatMoney(amount, 0, false));
  }

  /**
   * Retrieves the current value of the refund amount input field.
   *
   * @returns {*|Decimal}
   */
  getRefundAmount() {
    return Format.parseMoney(this.ui.amount.val());
  }

  /**
   * Event handler for when the amount input field has changed.
   */
  amountChanged() {
    this.trigger(_Event.REFUND_BY_REF_AMOUNT_CHANGED, Format.parseDecimal(this.ui.amount.val()));
  }
}
